import {makeAutoObservable, observable} from 'mobx';

import {Boost, User} from '@/domain/models';
import {MapBounds} from '@/shared/lib/react-query/types';

import {MapOnboardingSteps} from './types';

class Store {
  readonly boosts = observable.map<Boost['user_id'], Boost>();
  private _mapBounds: MapBounds | null = null;
  private _mapZoom: number = 3;
  private _myBoost?: Boost;
  private _fetched: boolean = false;
  private _mapOnboardingStep: MapOnboardingSteps =
    MapOnboardingSteps.simpleBoostOnboarding;

  constructor() {
    makeAutoObservable(this);
  }

  get fetched() {
    return this._fetched;
  }

  get myBoost() {
    return this._myBoost;
  }

  get mapOnboardingStep() {
    return this._mapOnboardingStep;
  }

  setMapOnboardingStep(step: MapOnboardingSteps) {
    this._mapOnboardingStep = step;
  }

  setMyBoost(boost?: Boost) {
    this._myBoost = boost;
  }

  get mapBounds() {
    return this._mapBounds;
  }

  setMapBounds(mapBounds: MapBounds | null): void {
    this._mapBounds = mapBounds;
  }

  get asBoostsArray(): Boost[] {
    return Array.from(this.boosts.values());
  }

  add(boost: Boost) {
    this.boosts.set(boost.user_id, boost);
  }

  addMultiple(boosts: Boost[]) {
    this.boosts.merge(boosts.map((boost) => [boost.user_id, boost]));
    this._fetched = true;
  }

  resetBoosts() {
    this.boosts.clear();
    this._fetched = false;
  }

  removeBoostByUser(id: User['id']): void {
    this.boosts.delete(id);
  }

  removeBoostByBoostId(id: Boost['id']): void {
    const boost = Array.from(this.boosts.values()).find(
      (boost) => boost.id === id
    );
    if (!boost) {
      return;
    }

    this.removeBoostByUser(boost.user_id);
  }

  get mapZoom() {
    return this._mapZoom;
  }

  setMapZoom(zoom: number) {
    this._mapZoom = zoom;
  }

  getBoostByUserId(id: User['id']) {
    return this.boosts.get(id);
  }
}

export default new Store();
